import { useAuth } from '@clerk/react'
import { Navigate } from 'react-router-dom'
import { Center, Loader, Stack, Text } from '@mantine/core'
import { useSession } from '../../api'
import ProtectedRoute from '../auth/ProtectedRoute'

const AdminRoute = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth()
  const { isAdmin, status } = useSession()

  // Auth state is settled once Clerk has loaded AND the session (/me, which
  // carries the role) is no longer connecting. Redirecting before that point
  // bounces signed-in admins home on cold deep-links.
  const authSettled = isLoaded && status !== 'connecting'

  return (
    <ProtectedRoute requireAuth={true} redirectTo="/">
      {!authSettled ? (
        <Center h="100vh">
          <Stack align="center" gap="md">
            <Loader size="lg" />
            <Text size="sm" c="dimmed">
              Checking authentication...
            </Text>
          </Stack>
        </Center>
      ) : isSignedIn && !isAdmin ? (
        <Navigate to="/" replace />
      ) : (
        children
      )}
    </ProtectedRoute>
  )
}

export default AdminRoute
